import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  imports: [CommonModule],
})
export class ImageGalleryComponent {
  //#region properties
  images: any[] = [];
  currentIndex: number = 0;
  imageUrl: string = '';
  imageTitle: string = '';
  apiUrl: string = AppConfigService.config.apiUrl;
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<ImageGalleryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.images = this.data?.images || [];
    const currentImage = this.data?.currentImage;
    this.currentIndex = this.images.findIndex(
      (item) => item?.filePath === currentImage
    );
    this.updateImageInfo();
  }

  updateImageInfo(): void {
    if (this.images.length > 0) {
      const { filePath, title } = this.images[this.currentIndex] || {};
      this.imageUrl = filePath || '';
      this.imageTitle = title || '';
    }
  }

  get isNextImageDisabled(): boolean {
    return this.currentIndex + 1 >= this.images.length;
  }

  get isPreviousImageDisabled(): boolean {
    return this.currentIndex <= 0;
  }

  nextImage(): void {
    if (!this.isNextImageDisabled) {
      this.currentIndex++;
      this.updateImageInfo();
    }
  }

  previousImage(): void {
    if (!this.isPreviousImageDisabled) {
      this.currentIndex--;
      this.updateImageInfo();
    }
  }

  onModalClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    if (
      !targetElement.closest('img') &&
      !targetElement.closest('.mdi-chevron-right') &&
      !targetElement.closest('.mdi-chevron-left') &&
      !targetElement.closest('.image-btn') &&
      !targetElement.closest('.mdi-close')
    )
      this.onClose();
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
